import { useDirection } from '@mantine/core';
import { useEffect } from 'react';

import { useLearningObjectSnapshotAndDraftQuery } from './useLearningObjectSnapshotAndDraftQuery';
import { useWorkMode } from './useWorkMode';
import { SupportedLocale } from '@/types/SupportedLocale';
import { getDirectionFromLanguage } from '@/utils/locale.utils';

export function useContentLanguage() {
  const { learningObjectDraft, learningObjectSnapshot, isLoading, isError } = useLearningObjectSnapshotAndDraftQuery();

  const { isPlayer } = useWorkMode();

  const contentLanguage = (
    isPlayer ? learningObjectSnapshot?.language : learningObjectDraft?.language
  ) as SupportedLocale;
  const contentDirection = getDirectionFromLanguage(contentLanguage);

  const { setDirection } = useDirection();

  useEffect(() => {
    setDirection(contentDirection);
  }, [contentDirection, setDirection]);

  return {
    contentDirection,
    contentLanguage,
    isError,
    isLoading
  };
}
